module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-aversion"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('Update_LOG'),
      "url": "/opera/version",
      "replace": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoList"
  }, [_c('ul', {
    staticClass: "tip"
  }, [_c('li', [_c('h2', [_vm._v("V1.0.0（2018-05-08）")])]), _vm._v(" "), _c('li', [_vm._v("1、MiHotel Opera版本隆重上线")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3afe3dd7","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/versionDetail.vue
// module id = 1770
// module chunks = 107